import {
  IGetSemesterCoursesSubject,
  ISemesterCoursesSubjectBody,
  ISemesterCoursesSubjectParams,
  ISemesterCoursesSubjectUpdateBody,
} from '../models/semesterCoursesSubject.model';
import axios, { AxiosPromise } from 'axios';

const url = '/mgmt/semester-courses/subject';

export const postSemesterCoursesSubject = (
  body: ISemesterCoursesSubjectBody[],
) => axios.post(url, body);

export const getSemesterCoursesSubject = (
  params: ISemesterCoursesSubjectParams,
): AxiosPromise<IGetSemesterCoursesSubject> => axios.get(url, { params });

export const putSemesterCoursesSubject = (
  body: ISemesterCoursesSubjectUpdateBody[],
) => axios.put(url, body);
